import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../..";

import ChooseAreaStep from "../../../../../../shared/wizard/steps/chooseAreaStep";

interface IWishStep_1 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStep_1 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: IWishStep_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.step_2);
    onReset(["desiredLocationIds"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_2);
  };

  return (
    <div>
      <ChooseAreaStep
        isNextStepDisabled={isNextStepDisabled}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        data={data}
        onChange={onChange}
      />
    </div>
  );
};

export default WishStep_1;
